export default __webpack_public_path__ + "static/media/ic_bg_price.b9b7439b.svg";